<template>
<div class="chapter">
<div class="inner_page">
<h1>Alluring Lettuces</h1>
<div class="toc">
<dl>
<dt>
<span class="chapter">
<a href="#/ch01">Introduction</a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch02">1. Amaranth ‘Joseph’s Coat’</a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch03">2. Artichoke ‘Violetto di Romagna’</a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch04">3. Asparagus Bean (Yard Long White Snake)</a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch05">4. Asparagus Pea</a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch06">5. Australian Yellowleaf Lettuce </a>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch07" title="Link target outside of Sample">6. Broccoli ‘Romanesco’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch08" title="Link target outside of Sample">7. Brussels Sprout ‘Rubine’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch09" title="Link target outside of Sample">8. Bull’s Blood Beet</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch10" title="Link target outside of Sample">9. Cabbage ‘Ruby Perfection’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch11" title="Link target outside of Sample">10. Cabbage ‘Savoy Express’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch12" title="Link target outside of Sample">11. Cardoon ‘Gigante’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch13" title="Link target outside of Sample">12. Carrot ‘Thumbelina’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch14" title="Link target outside of Sample">13. Cauliﬂower ‘Violetta di Sicilia’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch15" title="Link target outside of Sample">14. Cayenne Pepper</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch16" title="Link target outside of Sample">15. Celeriac</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch17" title="Link target outside of Sample">16. Chard ‘Bright Lights’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch18" title="Link target outside of Sample">17. Chinese Rat Tail Radish</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch19" title="Link target outside of Sample">18. Chiogga Beet</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch20" title="Link target outside of Sample">19. Crimson Forest Onion</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch21" title="Link target outside of Sample">20. d’Algers Melon</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch22" title="Link target outside of Sample">21. Dragon Tongue Bush Bean</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch23" title="Link target outside of Sample">22. Dwarf Blue Curled Scotch Kale</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch24" title="Link target outside of Sample">23. Early Purple Vienna Kohlrabi</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch25" title="Link target outside of Sample">24. Eggplant ‘Neon’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch26" title="Link target outside of Sample">25. Egyptian Walking Onion</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch27" title="Link target outside of Sample">26. Elberta Peach Tomato</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch28" title="Link target outside of Sample">27. Fish Pepper</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch29" title="Link target outside of Sample">28. ‘German Red Strawberry’ Tomato</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch30" title="Link target outside of Sample">29. Giant Chinese Red Mustard</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch31" title="Link target outside of Sample">30. Giant Red Celery</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch32" title="Link target outside of Sample">31. Golden Sweet Edible-Podded Pea</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch33" title="Link target outside of Sample">32. Green Zebra Tomato</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch34" title="Link target outside of Sample">33. Habañero Pepper</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch35" title="Link target outside of Sample">34. Hillbilly Tomato</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch36" title="Link target outside of Sample">35. Imperial Star Artichoke</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch37" title="Link target outside of Sample">36. Jarrahdale Pumpkin</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch38" title="Link target outside of Sample">37. Kale Nero di Toscana</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch39" title="Link target outside of Sample">38. Leek ‘Blue Solaise’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch40" title="Link target outside of Sample">39. Lemon Drop Pepper</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch41" title="Link target outside of Sample">40. Lettuce ‘Forellenschluss’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch42" title="Link target outside of Sample">41. Lollo Rossa Lettuce</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch43" title="Link target outside of Sample">42. Malabar Spinach</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch44" title="Link target outside of Sample">43. Melon ‘Queen Anne’s Pocket’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch45" title="Link target outside of Sample">44. Merlot Lettuce</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch46" title="Link target outside of Sample">45. Mizuna</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch47" title="Link target outside of Sample">46. Nutri-Red Carrot</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch48" title="Link target outside of Sample">47. Okra ‘Red Burgundy’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch49" title="Link target outside of Sample">48. Orach ‘Crimson Plume’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch50" title="Link target outside of Sample">49. Osterei Eggplant</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch51" title="Link target outside of Sample">50. Painted Serpent Cucumber</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch52" title="Link target outside of Sample">51. Prescott Fond Blanc Melon</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch53" title="Link target outside of Sample">52. Pumpkin ‘Baby Boo’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch54" title="Link target outside of Sample">53. Purple Calabash Tomato</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch55" title="Link target outside of Sample">54. Purple Sprouting Broccoli</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch56" title="Link target outside of Sample">55. Radish ‘Misato Rose’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch57" title="Link target outside of Sample">56. Redbor Kale</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch58" title="Link target outside of Sample">57. Rhubarb Chard</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch59" title="Link target outside of Sample">58. Royal Oakleaf Lettuce</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch60" title="Link target outside of Sample">59. Runner Bean ‘Painted Lady’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch61" title="Link target outside of Sample">60. Runner Bean ‘Sun Bright’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch62" title="Link target outside of Sample">61. Sea Kale</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch63" title="Link target outside of Sample">62. Sorrel ‘Silver Shield’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch64" title="Link target outside of Sample">63. Squash ‘Ronde de Nice’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch65" title="Link target outside of Sample">64. Sunburst Squash</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch66" title="Link target outside of Sample">65. Sweet Million Tomato</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch67" title="Link target outside of Sample">66. Tiger Tom Tomato</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch68" title="Link target outside of Sample">67. Trifetti Pepper</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch69" title="Link target outside of Sample">68. True Lemon Cucumber</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch70" title="Link target outside of Sample">69. Turkish Orange Eggplant</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch71" title="Link target outside of Sample">70. Watermelon ‘Moon &amp; Stars’</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch72" title="Link target outside of Sample">71. West Indian Burr Gherkin</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch73" title="Link target outside of Sample">72. Windsor Broad Bean</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch74" title="Link target outside of Sample">73. Wood’s Prolific Bush Scallop Squash</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch75" title="Link target outside of Sample">74. Yellowstone Carrot</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch76" title="Link target outside of Sample">75. Zebra Hybrid Eggplant</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch77" title="Link target outside of Sample">Resources</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01-toc.vue?26ecdb9c